import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../api';

interface AddCommentParams {
  postId: string;
  comment: string;
}

const addComment = async ({ postId, comment }: AddCommentParams) => {
  if (!comment.trim()) {
    throw new Error('Comment cannot be empty');
  }

  const { data: userData } = await supabase.auth.getSession();
  const userId = userData.session?.user.id;

  if (!userId) {
    throw new Error('User must be authenticated to comment');
  }

  const { data, error } = await supabase
    .from('post_comments')
    .insert({
      user_id: userId,
      post_id: postId,
      comment: comment,
      created_at: new Date().toISOString()
    })
    .select()
    .single();

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useAddPostComment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddCommentParams) => addComment(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['post-comments']);
      queryClient.invalidateQueries(['comments']);
    },
    onError: (error) => {
      console.error('Error adding comment:', error);
    }
  });
}
